import Fuse from 'fuse.js'

export function processSearchResults(data) {
    let fuse_suspended = true;
    if(!fuse_suspended) {
        let all_objects = data.movies.concat(data.subseries);
        let fuse = new Fuse(all_objects, fuseOptions());
        let results = fuse.search(data.query)

        if(results.length > 0) {
            data.movies = [];
            data.subseries= [];
            for (var idx in results) {
                let current_item = results[idx].item;
                current_item.sort_order = idx.toString();
                switch(current_item.kind) {
                    case 'movie':
                        data.movies.push(current_item);
                        break;
                    case 'subseries':
                        data.subseries.push(current_item);
                        break;
                    default:
                        break;
                }
            }
        }
    }

    return data;
}

function fuseOptions(){
    return {
        shouldSort: true,
        threshold: 0.6,
        location: 0,
        distance: 100,
        maxPatternLength: 32,
        minMatchCharLength: 1,
        keys: [
            "name",
            "titles",
            "description",
            "tags"
        ]
    };
}